import React, { useState } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  IconButton,
  Box,
  Typography,
  Grid,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MobileAppIcon from '../../../../static/outageIconsV2/mobile_app.svg';
import { useTranslation } from '../../../../hooks/useTranslation';
import { CustomDialog } from '../common/custom-dialog';
import { CONSTANTS } from '../../constants';
import colors from '../../../../themes/main-colors';
import ReactMarkdown from 'react-markdown/with-html';
import AppStoreImg from '../../../../images/app-store.png';
import PlayStoreImg from '../../../../images/play-store.png';
import { maxWidth } from '@material-ui/system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    trigger: {
      backgroundColor: colors.riverBlue,
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(5 / 2),
      cursor: 'pointer',
      borderBottom: `1px solid ${colors.grey2}`,
    },
    triggerHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    label: {
      fontSize: 16,
      fontWeight: 600,
      paddingLeft: theme.spacing(2),
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      padding: theme.spacing(3.75),
      margin: theme.spacing(2.5),
      backgroundColor: colors.white,
    },
    textBlock: {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: theme.spacing(3),
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      alignItems: 'end',
      [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        width: '100%',
      },
    },
    storeButton: {
      width: 200,
      height: 68,
      [theme.breakpoints.down('sm')]: {
        width: '80%',
      },
    },
    markdownText: {
      fontSize: 20,
      '& ul': {
        paddingLeft: theme.spacing(3),
      },
    },
  }),
);

export const GetMobileApp = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      {/* Trigger Box */}
      <Box className={classes.trigger} onClick={() => setOpen(true)}>
        <Box className={classes.triggerHeader}>
          <MobileAppIcon />
          <Typography variant="subtitle1" className={classes.label}>
            {t('GET_PGE_MOBILE_APP')}
          </Typography>
        </Box>
      </Box>

      {/* Dialog */}
      <CustomDialog
        open={open}
        onClose={() => setOpen(false)}
        title={t('PGE_MOBILE_APP')}
        titleBgColor={colors.riverBlue}
        titleTextColor={colors.noirBlur}
        dialogWidth={800}
      >
        <Box className={classes.section}>
          <Typography variant={'body1'} className={classes.textBlock}>
            {t('MANAGE_ACCOUNT_ANYWHERE_WITH_APP')}
          </Typography>

          <Grid container alignItems="center" justify="space-between">
            <Grid item xs={12} md={7}>
              <Box className="order-list" style={{ fontSize: 18 }}>
                <ReactMarkdown
                  source={t('PGE_MOBILE_APP_INFO')}
                  escapeHtml={false}
                  className={classes.markdownText}
                />
                {/* <Markdown renderer={markdownRenderer}>
                    {richT({
                      slug: 'PGE_MOBILE_APP_INFO',
                      dynamicValues: { undefined },
                    })}
                  </Markdown> */}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className={classes.buttonGroup}>
                <a
                  href={CONSTANTS.APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box className={classes.storeButton}>
                    <img src={AppStoreImg} alt="app store" />
                  </Box>
                </a>
                <a
                  href={CONSTANTS.PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box className={classes.storeButton}>
                    <img src={PlayStoreImg} alt="play store" />
                  </Box>
                </a>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CustomDialog>
    </>
  );
};
